import SubcategoryPage from '@/components/template/SubcategoryPage';

const LeseniUmivalniki = () => {
  const products = [
    {
      title: "Lesen Umivalnik Hrast",
      imageSrc: "https://images.unsplash.com/photo-1602028915047-37269d1a73f7?auto=format&fit=crop&q=80",
      url: "/umivalniki/leseni/hrast"
    },
    {
      title: "Lesen Umivalnik Oreh",
      imageSrc: "https://images.unsplash.com/photo-1617004518200-f3b8191fdc1d?auto=format&fit=crop&q=80",
      url: "/umivalniki/leseni/oreh"
    },
    {
      title: "Lesen Umivalnik Rustikalen",
      imageSrc: "https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&q=80",
      url: "/umivalniki/leseni/rustikalen"
    },
    {
      title: "Lesen Umivalnik Modern",
      imageSrc: "https://images.unsplash.com/photo-1600566752427-25ef8fb4e018?auto=format&fit=crop&q=80",
      url: "/umivalniki/leseni/modern"
    },
    {
      title: "Lesen Umivalnik Ročno Izdelan",
      imageSrc: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80",
      url: "/umivalniki/leseni/rocno-izdelan"
    },
    {
      title: "Lesen Umivalnik Premium",
      imageSrc: "https://images.unsplash.com/photo-1600566752610-111d521cf1de?auto=format&fit=crop&q=80",
      url: "/umivalniki/leseni/premium"
    }
  ];

  return (
    <SubcategoryPage
      title="Leseni Umivalniki"
      description="Doživite toplino in naravnost naših lesenih umivalnikov, ki v vašo kopalnico prinesejo pridih narave. Skrbno izbrani in obdelani kosi lesa nudijo edinstveno teksturo in karakter, vsak kos pa je unikaten umetniško delo."
      heroImage="https://images.unsplash.com/photo-1602028915047-37269d1a73f7?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default LeseniUmivalniki;